import { render, staticRenderFns } from "./WechatCallback.vue?vue&type=template&id=0b616cac&scoped=true"
import script from "./WechatCallback.vue?vue&type=script&lang=js"
export * from "./WechatCallback.vue?vue&type=script&lang=js"
import style0 from "./WechatCallback.vue?vue&type=style&index=0&id=0b616cac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b616cac",
  null
  
)

export default component.exports